import ALL_POSTS from "@/data/blogPosts.json";

export const POSTS = ALL_POSTS.filter((p) => p.published !== false);
export const SITE = "https://grandpafinns.com";
export const postBySlug = (slug) => POSTS.find((p) => p.slug === slug);

const plain = (md) => md.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1").replace(/\*\*|__|`/g, "").replace(/\s+/g, " ").trim();

export const faqFromBody = (body) => {
  const m = body.match(/^## Frequently asked questions\s*\n([\s\S]*?)(?=^## |(?![\s\S]))/m);
  if (!m) return [];
  return m[1].split(/^### /m).slice(1).map((chunk) => {
    const [q, ...rest] = chunk.split("\n");
    return { q: plain(q), a: plain(rest.join("\n")) };
  }).filter((x) => x.q && x.a);
};

export const morePosts = (slug, n = 3) => {
  const others = POSTS.filter((p) => p.slug !== slug);
  return others.slice(0, n);
};
